import { render, staticRenderFns } from "./KeywordColumnSettingsItem.vue?vue&type=template&id=825d880e"
import script from "./KeywordColumnSettingsItem.vue?vue&type=script&lang=js"
export * from "./KeywordColumnSettingsItem.vue?vue&type=script&lang=js"
import style0 from "./KeywordColumnSettingsItem.vue?vue&type=style&index=0&id=825d880e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports